import { render, staticRenderFns } from "./DocumentCell.vue?vue&type=template&id=aa0bc646&scoped=true&"
import script from "./DocumentCell.vue?vue&type=script&lang=js&"
export * from "./DocumentCell.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCell.vue?vue&type=style&index=0&id=aa0bc646&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0bc646",
  null
  
)

export default component.exports